import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "../../ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import React from "react";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import { useGetServiceTeamQuery } from "store/apis/serviceTeam";
import {
  FILTER_BOOKKEEPERS,
  UNASSIGNED_OPTION,
} from "../Task1120FilterOptions";
import { validate } from "uuid";

export const BookkeeperColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
}) => {
  const selectedTeams = values.SERVICE_TEAM || null;
  const serviceTeamIds = selectedTeams
    ?.split(",")
    .filter((id) => validate(id))
    .join(",");
  const { data: teamMembers = [] } = useGetServiceTeamQuery(
    { serviceTeamId: serviceTeamIds },
    { skip: !serviceTeamIds, refetchOnMountOrArgChange: true }
  );

  const updatedOptions = [
    { uuid: UNASSIGNED_OPTION, name: "Unassigned" },
    ...teamMembers,
  ];

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>Bookkeeper</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_BOOKKEEPERS}
        options={updatedOptions.map((member) => ({
          value: member.uuid,
          label: member.name,
        }))}
        selected={values.BOOKKEEPERS || null}
        updateFilter={updateFilter}
      />
    </div>
  );
};
